<template>
  <section class="policy-record">
    <aside>
      <div
        v-for="(item, index) in recordList"
        :key="index"
        class="policy-list">
        <div
          class="policy-item"
          :class="{'active': index == activeItem }"
          @click="recordClick(index, item.order_id)"
        >
          <span class="bold">{{ item.type_language }}</span>
          <span>{{ item.period }}</span>
        </div>
        <div
          v-if="item.period_record && item.period_record.length > 0"
          class="policy-status-list">
          <div
            v-for="(inItem, inIndex) in item.period_record"
            :key="inIndex"
            class="policy-status-item"
            :class="{'active': (index == activeItem && inIndex == activeInItem) }"
            @click="recordItemClick(index, inIndex, inItem.order_id)"
          >
            <span class="bold">{{ inItem.type_language }}</span>
            <span class="time">{{ inItem.period_start }}</span>
          </div>
        </div>
      </div>
    </aside>
    <section class="information-container">
      <div class="table">
        <div class="tr">
          <span>Effective Date</span>
          <span>{{ formData.period_start }} - {{ formData.period_end }}</span>
        </div>
        <div class="tr">
          <span>Total Price</span>
          <span>{{ formData.amount | formatMoney(2, true) }}</span>
        </div>
      </div>
      <div class="box">
        <h2>Excess</h2>
        <div class="table">
          <div class="tr th">
            <span>Item</span>
            <span>Amount</span>
          </div>
          <div
            v-for="inItem in excessList"
            :key="inItem.item"
            class="tr">
            <span>{{ inItem.item }}</span>
            <span>{{ inItem.premium }}</span>
          </div>
          <!-- <template v-if="classId == 14">
            <div class="tr">
              <span>Third Party Property Damage Excess</span>
              <span>{{ formData.tppd_ex | formatMoney(0) }}</span>
            </div>
            <div class="tr">
              <span>TPPD Young Driver Excess</span>
              <span>{{ formData.tppd_young_driver_ex | formatMoney(0) }}</span>
            </div>
            <div class="tr">
              <span>TPPD Inexperience Excess</span>
              <span>{{ formData.tppd_inexp_driver_ex | formatMoney(0) }}</span>
            </div>
            <div class="tr">
              <span>TPPD Unnamed Driver Excess</span>
              <span>{{ formData.tppd_unnamed_driver_ex | formatMoney(0) }}</span>
            </div>
            <div class="tr">
              <span>Remark</span>
              <span>{{ formData.remark }}</span>
            </div>
          </template>
          <template v-else>
            <div class="tr">
              <span>Own Damage</span>
              <span>{{ getExText(formData.general_ex, formData.general_ex_posi, formData.general_ex_or_pol) }}</span>
            </div>
            <div class="tr">
              <span>Own Damage (China)</span>
              <span>{{ getExText(formData.china_general_ex, formData.china_general_ex_posi, formData.china_general_ex_or_pol) }}</span>
            </div>
            <div class="tr">
              <span>Own Damage (Guangdong)</span>
              <span>{{ getExText(formData.gd_general_ex, formData.gd_general_ex_posi, formData.gd_general_ex_or_pol) }}</span>
            </div>
            <div class="tr">
              <span>Theft</span>
              <span>{{ getExText(formData.theft_loss_ex, formData.theft_loss_ex_posi, formData.theft_loss_ex_or_pol) }}</span>
            </div>
            <div class="tr">
              <span>Theft (China)</span>
              <span>{{ getExText(formData.china_theft_loss_ex, formData.china_theft_loss_ex_posi, formData.china_theft_loss_ex_or_pol) }}</span>
            </div>
            <div class="tr">
              <span>Theft (Guangdong)</span>
              <span>{{ getExText(formData.gd_theft_loss_ex, formData.gd_theft_loss_ex_posi, formData.gd_theft_loss_ex_or_pol) }}</span>
            </div>
            <div class="tr">
              <span>Parking</span>
              <span>{{ formData.parking_damage_ex | formatMoney(0) }}</span>
            </div>
            <div class="tr">
              <span>Own Damage Young Driver</span>
              <span>{{ formData.young_driver_ex | formatMoney(0) }}</span>
            </div>
            <div class="tr">
              <span>Own Damage Inexperienced Driver</span>
              <span>{{ formData.inexp_driver_ex | formatMoney(0) }}</span>
            </div>
            <div class="tr">
              <span>Own Damage Unnamed Driver</span>
              <span>{{ formData.unnamed_driver_ex | formatMoney(0) }}</span>
            </div>
            <div class="tr">
              <span>Third Party Property Damage</span>
              <span>{{ formData.tppd_ex | formatMoney(0) }}</span>
            </div>
            <div class="tr">
              <span>Third Party Property Damage Young Driver</span>
              <span>{{ formData.tppd_young_driver_ex | formatMoney(0) }}</span>
            </div>
            <div class="tr">
              <span>Third Party Property Damage Inexperienced Driver</span>
              <span>{{ formData.tppd_inexp_driver_ex | formatMoney(0) }}</span>
            </div>
            <div class="tr">
              <span>Third Party Property Damage Unnamed Driver</span>
              <span>{{ formData.tppd_unnamed_driver_ex | formatMoney(0) }}</span>
            </div>
            <div class="tr">
              <span>Remark</span>
              <span>{{ formData.remark }}</span>
            </div>
          </template> -->
        </div>
      </div>
      <div class="box">
        <h2>Coverage</h2>
        <div class="table">
          <div class="tr th">
            <span>Item</span>
            <span>Amount</span>
          </div>
          <div
            v-for="(item, index) in formData.coverage"
            :key="index"
            class="tr">
            <span>{{ item.item }}</span>
            <span>{{ item.premium }}</span>
          </div>
          <div
            v-for="(inItem) in formData.more_benefits"
            :key="inItem.item"
            class="tr">
            <span>{{ inItem.item }}</span>

            <span
              v-if="productId == 11"
              :class="[ inItem.premium == '√'? 'green': 'red' ]">{{ inItem.premium }}</span>
            <span v-else>{{ inItem.premium }}</span>
          </div>
          <!-- <template v-if="classId == 14">
            <div class="tr">
              <span>TPPD(Third Party Property Damage)</span>
              <span>{{ formData.tppd_limit_amt | formatMoney(0) }}</span>
            </div>
            <div class="tr">
              <span>TPBI(Third Party Bodily Injury)</span>
              <span>{{ formData.tpbi_limit_amt | formatMoney(0) }}</span>
            </div>
          </template>
          <template v-else>
            <div class="tr">
              <span>Own Damage</span>
              <span>{{ formData.isrd_vl | value | formatMoney(0) }}</span>
            </div>
            <div class="tr">
              <span>Third Party Death or Bodily Injury</span>
              <span>{{ formData.tpbi_limit_amt | value | formatMoney(0) }}</span>
            </div>
            <div class="tr">
              <span>Third Party Property Damage</span>
              <span>{{ formData.tppd_limit_amt | value | formatMoney(0) }}</span>
            </div>
            <div
              v-for="(item, index) in allBenefitsList"
              :key="index"
              class="tr">
              <span>{{ item.name }}</span>
              <span
                :class="[formData.benefits.includes(item.id)? 'green': 'red']"
              >{{ formData.benefits.includes(item.id)? '√': 'X' }}</span>
            </div>
          </template> -->
        </div>
      </div>
      <div class="box">
        <h2>Policyholder</h2>
        <policy-holder-info :form="formData" />
      </div>
      <div class="box">
        <h2>Insured Vehicle</h2>
        <insured-vehicle-info :form="formData" />
      </div>
      <div class="box">
        <h1>Insured Driver(s)</h1>
        <drivers-info :form="formData" />
      </div>
      <div class="box">
        <h2>Remark(s)</h2>
        <div class="table strip">
          <div class="tr">
            <span>Remark</span>
            <span>{{ formData.remark }}</span>
          </div>
        </div>
      </div>
      <div class="box">
        <h2>Premium</h2>
        <div class="table">
          <div class="tr th">
            <span>Item</span>
            <span>Percentage</span>
            <span>Amount</span>
          </div>
          <div class="tr">
            <span>Basic Premium</span>
            <span>-</span>
            <span>{{ formData.pre_basic_prm | formatMoney(2, true) }}</span>
            <!-- <span>{{ formData.base_prm | formatMoney(2, true) }}</span> -->
          </div>
          <div class="tr">
            <span>Client Discount</span>
            <span>{{ formData.srd_pct }}%</span>
            <span>{{ formData.srd_amt | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>Loading</span>
            <span>{{ formData.loading_pct }}%</span>
            <span>{{ formData.loading_amt | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>NCD</span>
            <span>{{ formData.ncd_pct }}%</span>
            <span>{{ formData.ncd_vl | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>MGM Discount</span>
            <span>-</span>
            <span>{{ formData.code_disc_prm | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>MIB</span>
            <span>{{ formData.mib_pct }}%</span>
            <span>{{ formData.mib_vl | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>Levy</span>
            <span>{{ formData.ia_levy_pct }}%</span>
            <span>{{ formData.ia_levy_vl | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>Manual Discount</span>
            <span>{{ formData.spec_disc_pct }}%</span>
            <span>{{ formData.spec_disc_prm | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>Total Premium</span>
            <span>-</span>
            <span>{{ formData.amount | formatMoney(2, true) }}</span>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>
<script>
import MixinFormat from '@/mixins/format'
import MixinOptions from '@/mixins/options'
import InsuredVehicleInfo from '@/views/components/insured-vehicle-info'
import PolicyHolderInfo from '@/views/tickets/components/info/policy-holder-info'
import DriversInfo from '@/views/tickets/components/info/drivers-info'
import { getPolicyDetail } from '@/api/policy'

export default {
  name: 'PolicyRecord',
  components: {
    InsuredVehicleInfo,
    PolicyHolderInfo,
    DriversInfo,
  },
  mixins: [MixinFormat, MixinOptions],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      formData: {
        code_disc_prm: '',
        code_disc_pct: ''
      },
      activeItem: 0,
      activeInItem: 0
    }
  },
  computed: {
    classId() {
      return this.form.class_id || 14
    },
    allBenefitsList() {
      if (this.classId == 14) return []
      return this[`allOptions${this.classId}`].benefits || []
    },
    recordList() {
      // 可能要改一下
      if (!this.form.record) return []
      return this.form.record.reduce((result, item) => {
        result.push({
          ...item,
          open: false
        })
        return result
      }, [])
    },
    excessList(){
      let {quote_coverage_list} = this.form||{}
      let {excess} = quote_coverage_list||{}
      let {items} = excess||{}
      if(items){
        return items[0].sub_items
      }
      return  []
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        // 尋找索引
        if (val.record) {
          const { id, record } = val
          record.some((item, index) => {
            if (item.order_id == id) {
              this.activeItem = index
              return true
            }
            let { period_record = [] } = item
            if (period_record.length > 0) {
              let flag = false
              period_record.some((inItem, inIndex) => {
                if (inItem.order_id == id) {
                  this.activeItem = index
                  this.activeInItem = inIndex
                  flag = true
                  return true
                }
              })
              if (flag) return true
            }
          })
        }
        this.formData = JSON.parse(JSON.stringify(val)) // 默認賦值
      }
    }
  },
  methods: {
    submitForm() {
      this.$emit('submit', this.formData)
    },
    recordClick(index, id) {
      this.activeItem = index
      this.network().getPolicyDetail(id)
    },
    recordItemClick(index, inIndex, id) {
      this.activeItem = index
      this.activeInItem = inIndex
      this.network().getPolicyDetail(id)
    },
    network() {
      return {
        getPolicyDetail: async id => {
          const { data } = await getPolicyDetail({
            order_id: id
          })
          this.formData = data
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.policy-record {
  display: flex;
  aside {
    margin-right: 15px;
    width: 218px;
    .active {
      background: #d9ecff;
    }
    .policy-list {
      color: #409eff;
      font-size: 12px;
      .bold {
        font-weight: 500;
        font-size: 14px;
      }
      .policy-item {
        padding: 8px;
        cursor: pointer;
        span {
          display: block;
        }
      }
      .policy-status-list {
        margin-top: 1px;
        text-align: right;
        .policy-status-item {
          display: inline-block;
          padding: 8px;
          cursor: pointer;
          .time {
            display: inline-block;
            padding-left: 30px;
          }
        }
      }
    }
  }
   .information-container {
    flex: 1;
    .box {
      margin-bottom: 10px;
      h2 {
        padding-bottom: 5px;
      }
    }
  }
}
</style>
